import * as Request from '../Request';
const Template = {
  // 新增模板文件
  addFile: (data) => {
    return Request.post('/DocTemplate/file/save', data);
  },
  // 删除模板文件
  delFile: (data) => {
    return Request.delBody('/DocTemplate/file/delete', data);
  },
  // 修改模板文件
  editFile: (data) => {
    return Request.put('/DocTemplate/file/update', data);
  },
  // 模板文件列表
  getFileList: (data) => {
    return Request.post('/DocTemplate/file/list', data);
  },
  // 模板文件详情
  getFileInfo: (data) => {
    return Request.get('/DocTemplate/file/info', data)
  },
  // 目录列表
  getCatalogueList: (data) => {
    return Request.post('/DocTemplate/list', data);
  }
}
export default Template
